import { render, staticRenderFns } from "./PopAlert.vue?vue&type=template&id=d829f810&"
import script from "./PopAlert.vue?vue&type=script&lang=js&"
export * from "./PopAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports